// extracted by mini-css-extract-plugin
module.exports = {"page_content":"style_page_content__7kDEV"};